import config from '__api/config';
import Mask from '__components/Mask';
import { openUrl } from '__utils/openUrl';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

interface Props {
  tipText?: string;
  onPress?: Function;
}

interface State {
  isShow: boolean;
  msg: string;
  statusCode: number;
}
/**
 * 安全提示弹窗，三要素认证
 * */
export class SafeTipPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
      msg: '',
      statusCode: 0,
    };
  }

  show = (msg: string, statusCode: number) => {
    this.setState({ isShow: true, msg: msg, statusCode: statusCode });
  };

  hide = () => {
    this.setState({ isShow: false });
  };
  jumpPage = (code: number) => {
    switch (code) {
      case 6000: //当前提现人数太多，请稍后再试
      case 6001: // 很抱歉，已有其他账号使用该身份证在本活动中进行提现，此次提现失败
      case 6005: //很抱歉，您的手机号实名与身份证信息不符，请更换手机号
        break;
      case 6006: //您参与活动的手机号与实名手机号不一致，请使用参与活动的手机号188****8888进行提现
        openUrl('https://maccount2.eastmoney.com/mobile/bind/changemobile'); //更换手机号
        break;
      case 6002: //为了您能够顺利提现，请先去完成实名认证
        openUrl(config.identityUrl);
        break;
      case 6003: //为了您能够顺利提现，请先完成人脸识别验证
        openUrl(config.faceUrl);
        break;
      default:
        break;
    }
  };
  render() {
    const { onPress } = this.props;
    const { isShow, msg, statusCode } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 0.19 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(24)} />
                <Image
                  style={styles.safeTip}
                  source={require('../../images/invite/safeTip.png')}
                  resizeMode={'stretch'}
                />
                <Spacer size={rpx(22)} />
                <Text style={styles.text}>{msg}</Text>
                <Spacer size={rpx(30)} />
                <EmTouchableOpacity
                  onPress={() => {
                    onPress && onPress();
                    this.jumpPage(statusCode);
                    this.hide();
                  }}
                >
                  {[6002, 6003, 6006].includes(statusCode) ? (
                    <Image
                      style={styles.completeBtn}
                      source={require('../../images/invite/toCompleteBig.png')}
                      resizeMode={'stretch'}
                    />
                  ) : (
                    <Image
                      style={styles.iKnow}
                      source={require('../../images/invite/iKnow.png')}
                      resizeMode={'stretch'}
                    />
                  )}
                </EmTouchableOpacity>
                <Spacer size={rpx(24)} />
              </LinearGradient>
              <EmTouchableOpacity
                onPress={() => {
                  this.hide();
                }}
              >
                <Image
                  style={styles.closeImg}
                  source={require('../../images/invite/closeBtn.png')}
                  resizeMode={'stretch'}
                />
              </EmTouchableOpacity>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
  },
  iKnow: { width: rpx(210), height: rpx(52) },
  text: {
    fontSize: rpx(14),
    width: rpx(160),
    color: '#333333',
    lineHeight: rpx(24),
    textAlign: 'center',
  },
  safeTip: {
    width: rpx(94),
    height: rpx(21),
  },
  completeBtn: {
    width: rpx(211),
    height: rpx(41),
  },
  closeImg: {
    marginTop: rpx(20),
    width: rpx(56),
    height: rpx(41),
  },
});
